import axios from 'axios'
import moment from 'moment'
import Utils from '../../utils/utils'
import vue from 'vue'
import config from '../../config'
export async function getStayAverageData(condition = {}) {
  let response = {}
  if (Utils.isEmptyObject(condition.startTime) || Utils.isEmptyObject(condition.endTime)) {
    console.error('iisi getStayAverageData: time is null')
    return response
  }

  // StayAverage?sttime=2022/07/27%2012:00&endtime=2022/07/29%2012:00&&area=1&&type=(2是違規闖入4是封閉預警)

  let startTime = encodeURIComponent(moment(condition.startTime).startOf('day').format().split('+')[0]) //2022-08-05T14:41:00+08:00 移除時區(+之後)
  let startTimeQuery = startTime ? `?sttime=${startTime}` : ''
  let endTime = encodeURIComponent(moment(condition.endTime).endOf('day').format().split('+')[0])
  let endTimeQuery = startTime ? `&endtime=${endTime}` : ''
  let scenicAreaIdQuery = Utils.isEmptyObject(condition.scenicAreaId) ? '' : `&area=${condition.scenicAreaId}`


  try {
      response = await vue.http.get(`/api/StayAverage/StayAverage${startTimeQuery}${endTimeQuery}${scenicAreaIdQuery}`)

  } catch (err) {
      console.error('iisi getStayAverageData: ', err)
      return response
  }

  Utils.setApiResponsSuccess(response)
  return response
}

export async function getStayAverageByDate(condition = {}) {
  let response = {}
  if (Utils.isEmptyObject(condition.startTime) || Utils.isEmptyObject(condition.endTime)) {
    console.error('iisi getStayAverageData: time is null')
    return response
  }

  // StayAverage?sttime=2022/07/27%2012:00&endtime=2022/07/29%2012:00&&area=1&&type=(2是違規闖入4是封閉預警)

  let startTime = encodeURIComponent(moment(condition.startTime).startOf('day').format().split('+')[0]) //2022-08-05T14:41:00+08:00 移除時區(+之後)
  let startTimeQuery = startTime ? `?sttime=${startTime}` : ''
  let endTime = encodeURIComponent(moment(condition.endTime).endOf('day').format().split('+')[0])
  let endTimeQuery = startTime ? `&endtime=${endTime}` : ''
  let scenicAreaIdQuery = Utils.isEmptyObject(condition.scenicAreaId) ? '' : `&area=${condition.scenicAreaId}`

  try {
    response = await vue.http.get(`/api/StayAverage/StayAverageByDate${startTimeQuery}${endTimeQuery}${scenicAreaIdQuery}`)

  } catch (err) {
      console.error('iisi getStayAverageByDate: ', err)
      return response
  }

  Utils.setApiResponsSuccess(response)
    return response
}


export async function getStayAverageWholeInterval(condition={}){
  let response = {}
  if (Utils.isEmptyObject(condition.sttime) || Utils.isEmptyObject(condition.endtime)) {
    console.error('iisi getStayAverageData: time is null')
    return response
  }

  try {
      response = await vue.http.post(`${config.eastCoastDataApi()}StayAverageElk/StayAverageWholeInterval`,condition)

  } catch (err) {
      console.error('iisi getStayAverageData: ', err)
      return response
  }

  Utils.setApiResponsSuccess(response)
  return response.body
}

export async function getStayAverageInterval(condition={}){
  let response = {}
  if (Utils.isEmptyObject(condition.sttime) || Utils.isEmptyObject(condition.endtime)) {
    console.error('iisi getStayAverageData: time is null')
    return response
  }

  try {
      response = await vue.http.post(`${config.eastCoastDataApi()}StayAverageElk/StayAverageInterval`,condition)

  } catch (err) {
      console.error('iisi getStayAverageData: ', err)
      return response
  }

  Utils.setApiResponsSuccess(response)
  return response.body
}